import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import EntityLaunchpanel from "../../Partials/Launchpanel/EntityLaunchpanel";
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Select from "../../Partials/Material/Select";
import TextField from "../../Partials/Material/TextField";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AgreementUpdateWillMount from "../../../Middleware/Middlewares/AgreementUpdateWillMount";
import Time from "../../../Time/Time";
import ReactSelect from 'react-select';
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import { AgencyFeeInterface } from "../../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import AssignmentServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/AssignmentServiceStatusTypeContainer";
import MenuItem from '@material-ui/core/MenuItem';
import AgreementCard from "../../Partials/Agreement/AgreementCard";

class AgreementUpdate extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_AGENCY_FEE_UPDATE_CLEAR;
  
  protected middlewares: MiddlewareInterface[] = [
    AgreementUpdateWillMount,
    PreventPageLeave
  ];

  public state = {
    agencyFee: null,
    currency: null,
    fixedFee: null,
    percentageFee: null,
    fixedPlusPercentageMode: null,
    vat: null,
    vatPercentage: null,
    firstDate: null,
    lastDate: null,
    dateChoice: null,
    firstDateError: "",
    chargeTypeIds: [],
    repeatPeriod: null,
    assignmentServiceStatus: null,
    hasModifiedData: false,
    isSaving: false,
    nextPath: "",
    openLeavePrompt: false,
    isErrorLaunchPanelOpen: false,
    isAgencyFeeRemoveDialog: false,
    isSignPopupOpen: false,
    isEndAgencyFeeDialogOpen: false,
    date: null,
    dateError: ""
  }

  constructor(public props) {
    super(props);
  }

  public componentWillUnmount() {
    if (this.state.nextPath) {
      this.redirect(this.state.nextPath);
    }
  }

  public initializePage = (agencyFee: AgencyFeeInterface) => {
    if (!agencyFee) {
      return this.redirectBack();
    }

    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_UPDATE_CLEAR
    });

    let vatPercentage = "";

    if (agencyFee && agencyFee.fixedFee) {
      const vatPercentageNumber = Math.round(agencyFee.vat / (agencyFee.fixedFee - agencyFee.vat) * 100);

      if (!isNaN(vatPercentageNumber)) {
        vatPercentage = this.formatter.simpleFormatNumber(vatPercentageNumber, false, false);
      }
    }

    this.setState({
      agencyFee: agencyFee,
      currency: agencyFee && agencyFee.currency.getCurrencyId(),
      fixedFee: agencyFee && ((!agencyFee.fixedFee && agencyFee.fixedFee !== 0) ? "" : this.formatter.simpleFormatNumber(agencyFee.fixedFee)),
      percentageFee: this.formatter.simpleFormatNumber(agencyFee.percentageFee, false),
      fixedPlusPercentageMode: agencyFee && agencyFee.fixedPlusPercentageMode,
      vat: agencyFee && (!agencyFee.vat ? "" : this.formatter.simpleFormatNumber(agencyFee.vat)),
      vatPercentage: vatPercentage,
      firstDate: agencyFee && (!agencyFee.firstDate ? null : agencyFee.firstDate),
      lastDate: agencyFee && (!agencyFee.lastDate ? null : agencyFee.lastDate),
      dateChoice: !!agencyFee && agencyFee.firstDate ? "firstDate" : "contractDate",
      firstDateError: "",
      chargeTypeIds: agencyFee?.chargeTypeIds || [],
      repeatPeriod: agencyFee?.repeatPeriod,
      assignmentServiceStatus: agencyFee?.assignmentServiceStatus,
      hasModifiedData: false,
      isSaving: false,
      isSignPopupOpen: false,
      isEndAgencyFeeDialogOpen: false,
      date: agencyFee?.date,
    });
  }

  public save = (callback?): any => {
    if (!this.state.firstDate && this.state.dateChoice === "firstDate") {
      return this.setState({
        firstDateError: this.trans("be_ajv_not_validated")
      });
    } else {
      this.setState({
        firstDateError: ""
      });
    }

    const payload =  {
      id: this.state.agencyFee?.id,
      objectType: this.state.agencyFee?.objectType,
      objectId: this.state.agencyFee?.objectId,
      currency: this.state.currency,
      fixedFee: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(",", ".")).toFixed(2)),
      percentageFee: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.percentageFee)).replace(",", ".")).toFixed(2)),
      vat: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.vat)).replace(",", ".")).toFixed(2)),
      firstDate: this.state.dateChoice === "firstDate" ? Time.formatOrNull(this.state.firstDate) : null,
      lastDate: Time.formatOrNull(this.state.lastDate),
      fixedPlusPercentageMode: this.state.fixedPlusPercentageMode?.id,
      chargeTypeIds: this.state.chargeTypeIds,
      repeatPeriodId: this.state.repeatPeriod,
      serviceStatusId: this.state.assignmentServiceStatus,
      date: Time.formatOrNull(this.state.date),
    };

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_UPDATE_START,
        payload: {
          ...payload
        },
        onSuccess: (agencyFee: AgencyFeeInterface) => {
          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("dialog/postprocess-info/agencyfeeupdate"),
              type: "info"
            }
          });

          if (typeof callback === "function") {
            return callback();
          }

          if (this.state.nextPath) {
            return this.redirect(this.state.nextPath);
          }

          this.initializePage(agencyFee);
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          })
        }
      });
    });
  }

  public sign = (): any => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_SIGN_START,
        payload: {
          id: this.state.agencyFee?.id
        },
        onSuccess: (agencyFee: AgencyFeeInterface) => {
          this.initializePage(agencyFee);
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          })
        }
      });
    });
  }

  public setEndDate = (): any => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_END_START,
        payload: {
          id: this.state.agencyFee?.id,
          lastDate: Time.formatOrNull(this.state.lastDate)
        },
        onSuccess: (agencyFee: AgencyFeeInterface) => {
          this.initializePage(agencyFee);
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          })
        }
      });
    });
  }

  
  public updateFPPMode = (event) => {
    const fpp = this.props.globalTypes?.FixedPlusPercentageModes?.[event.target.value];

    this.setState({
      fixedPlusPercentageMode: fpp,
      hasModifiedData: true
    });
  }

  public changeFixedFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    if (this.state.vat) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.vat)).replace(",", ".")).toFixed(2));
      vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

      let varPercentage = vatNumber / (fixedFee - vatNumber) * 100;

      return this.setState({
        vatPercentage: isFinite(varPercentage) ? this.formatter.simpleFormatNumber(Math.round(varPercentage), false, false) : "",
        fixedFee: amount,
        hasModifiedData: true
      });
    }

    if (this.state.vatPercentage) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.vatPercentage)).replace(",", ".")).toFixed(2));
      vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

      const vatNumber = fixedFee / (100 + vatPercentageNumber) * vatPercentageNumber;

      return this.setState({
        vat: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
        fixedFee: amount,
        hasModifiedData: true
      });
    }

    return this.setState({
      vat: "",
      vatPercentage: "",
      fixedFee: amount,
      hasModifiedData: true
    });
  }

  public changeVatAmount = (event): void => {
    let vat: string = event.target.value;
    vat = this.formatter.formatSigns(vat);

    let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(",", ".")).toFixed(2));
    fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

    let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vat)).replace(",", ".")).toFixed(2));
    vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

    const vatPercentageNumber = vatNumber / (fixedFee - vatNumber) * 100;

    this.setState({
      vat: vat,
      vatPercentage: this.formatter.simpleFormatNumber(Math.round(vatPercentageNumber), false, false),
      hasModifiedData: true
    });
  }

  public changeVatPercentageAmount = (event): void => {
    let vatPercentage: string = event.target.value;
    vatPercentage = this.formatter.formatSigns(vatPercentage);

    let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(",", ".")).toFixed(2));
    fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

    let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vatPercentage)).replace(",", ".")).toFixed(2));
    vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

    const vatNumber = fixedFee / (100 + vatPercentageNumber) * vatPercentageNumber;

    this.setState({
      vat: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
      vatPercentage: vatPercentage,
      hasModifiedData: true
    });
  }

  public changePercentageFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      percentageFee: amount,
      hasModifiedData: true
    });
  }

  public selectDate = (date: Date, identifier: string, callback?): void => {
    this.setState({
      [identifier]: date,
      hasModifiedData: true
    }, () => {
      if (typeof callback === "function") {
        callback();
      }
    })
  }

  public changeDateChoice = (event: any): void => {
    const choice: string = event.target.value;

    this.setState({
      dateChoice: choice,
      hasModifiedData: true
    });
  }

  public onChargeTypesSelectChange = (valArray) => {
		const types = !!valArray ? valArray.map(item => item.value) : [];

		this.setState({
      chargeTypeIds: [...types],
      hasModifiedData: true
		});
  }

  public renderChargeTypesSelect = () => {
    const chargeTypes = TypeContainer.getChargeTypesForChargeTemplates("agencyfee")
                      .filter(type => {
                        if(type.removed){
                          return false;
                        }

                        if(type.id === -1 || type.id === -2){
                          return false;
                        }

                        if(TypeContainer.pickIdFromLabel("Stub_receivable") === type.id || TypeContainer.pickIdFromLabel("Stub_payable") === type.id) {
                          return false;
                        }

                        return true;
                      })
                      .map(type => {
                        return ({
                            value: type.id,
                            label: this.formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)
                          });
                        }
                      );

    const customStyles = {
      control: (base, state) => {
        let borderColor = 'rgba(0, 0, 0, 0.23)';
        let boxShadow = 'none !important';
        let outlineColor = "auto";

        if (state.isFocused) {
          borderColor = "#00BCD4 !important";
          boxShadow = "0 0 1px 1px #00BCD4 !important";
          outlineColor = "#00BCD4 !important";

          if (!!this.getErrorFor("chargeTypeIds")) {
            borderColor = "#f44336 !important";
            boxShadow = "0 0 1px 1px #f44336 !important";
            outlineColor = "#f44336 !important";
          }
        } else {
          if (!!this.getErrorFor("chargeTypeIds")) {
            borderColor = "#f44336 !important";
            outlineColor = "#f44336 !important";
          }
        }

        return ({
          ...base,
          border: state.isFocused ? 'none !important' : "auto",
          borderColor: borderColor,
          boxShadow: boxShadow,
          outlineColor: outlineColor,
          outlineStyle: state.isFocused ? "auto !important" : "auto",
          outlineWidth: state.isFocused ? "5px !important"  : "auto",
          '&:hover': {
            borderColor: !!this.getErrorFor("chargeTypeIds") ? '#f44336' : 'black',
          }, // border style on hover
        });
      }
    }

    return (
      <div style={{position: "relative", zIndex: 2}}>
        <ReactSelect
          defaultValue={chargeTypes.filter(type => this.state.chargeTypeIds.includes(type.value))}
          isMulti
          options={chargeTypes}
          onChange={this.onChargeTypesSelectChange}
          styles={customStyles}
          placeholder={this.trans("dialog/agencyfee-field/chargetypes-label")}
          className="form-element scroll-to-charge-types"
          isDisabled={!this.state.agencyFee?.isConcept || this.state.agencyFee?.removed}
        />
        {!!this.getErrorFor("chargeTypeIds") && <div className="component-error-text">{this.getErrorFor("chargeTypeIds")}</div>}
        <div className="hint-styles-dialog" style={{margin: "-10px 0 10px 0"}}>
          {this.trans("dialog/agencyfee-info/chargetypes")}
        </div>
      </div>
    );
  }

  public changeAssignmentServiceStatus  = (event) => {
    const type: number = event.target.value;

    this.setState({
      assignmentServiceStatus: type,
      hasModifiedData: true,
      repeatPeriod: type === AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly")
    });
  }

  public deleteAgencyFee = () => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_DELETE_START,
        payload: this.state.agencyFee,
        onSuccess: () => {
          this.redirectBack();
        },
        onError: (e) => {
          if (e.blockingCharge) {
            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans("agreement-cannot-be-removed-because-of-locked-charges", { firstDate: this.formatter.formatDate(e.blockingCharge.firstDate), lastDate: this.formatter.formatDate(e.blockingCharge.lastDate) }),
                type: "error"
              }
            });
          }
          this.setState({
            isSaving: false
          });
        }
      });
    })
  }

  public render() {
    const activeContract = this.state?.agencyFee?.unit?.getActiveContract();

    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
        <div className="component-header has-back-button two-row-title">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <div className="title-wrapper">
                <h1>{`${this.trans("dialog/agreement-title")} - `}
                <span style={{color: this.state.agencyFee?.getStatusColor()}}>{this.trans(this.state.agencyFee?.status).toLowerCase()}</span></h1>
              </div>
              <div className="button-container">
                { this.state.agencyFee?.isConcept && (
                  <Button
                    color="primary"
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                                              action: "sign",
                                              entityName: "agreement",
                                              entity: this.state.agencyFee
                                            })) {
                        this.openIsBusyPopup();
                      } else {
                        this.setState({isSignPopupOpen: true});
                      }
                    }}
                    variant="outlined"
                    disabled={this.state.agencyFee?.removed}
                  >
                    {this.trans("sign")}
                  </Button>
                )}
                {
                  this.state.hasModifiedData && (
                    <Button
                      color="primary"
                      onClick={this.redirectBack}
                      disabled={this.state.agencyFee?.removed}
                    >
                      {this.trans("button-cancel")}
                    </Button>
                  )
                }
                <Button
                  color="primary"
                  onClick={this.state.hasModifiedData ? this.save : this.redirectBack}
                  variant="contained"
                  disabled={this.state.isSaving}
                >
                  {this.state.hasModifiedData ? this.trans("button-save") : this.trans("label-done")}
                </Button>
              </div>
            </div>
            <div className="inner-wrapper" style={{flexDirection: "column", alignItems: "flex-start"}}>
              <h4>{this.state.agencyFee?.unit?.displayName}</h4>
            </div>
          </div>

          <div className="box component-task-update">
            <div className="component-wrapper no-margin-top no-shadow">
              <div>
                <div className="component" style={{boxShadow: "0 3px 6px 0 rgb(0 0 0 / 10%)"}}>
                  <AgreementCard 
                    {...this.props}
                    key={`agreement-${this.state.agencyFee?.id}`}  
                    agencyFee={this.state.agencyFee}
                    mainCardPresentation={true}
                    openedByDefault={true}
                    editableFields={
                      <div className="component">
                        <Card className="card">
                          <div
                            style={{
                              padding: "0px 40px 10px 0px",
                              maxWidth: "420px"
                            }}
                          >
                            <DatePickerComponent
                              {...this.props}
                              id="date"
                              name="date"
                              className="scroll-to-date"
                              label={this.trans("coach/newagreement/date-agreement")}
                              initialDate={this.state.date}
                              maxDate={activeContract && activeContract?.firstDate}
                              onChange={date => this.selectDate(date, "date")}
                              clearButton={true}
                              margin={"0 0 14px 0"}
                              width="70%"
                              error={this.getErrorFor("date") || this.state.dateError}
                            />

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div style={{display: "flex", flexDirection: "column", width: "70%", marginRight: "10px"}}>
                                <TextField
                                  autoComplete="off"
                                  className="full-size scroll-to-fixedFee"
                                  type="text"
                                  label={this.trans("dialog/agencyfee-field/fixedfee-label")}
                                  value={this.state.fixedFee}
                                  onChange={this.changeFixedFeeAmount}
                                  autoFocus={true}
                                  variant="standard"
                                  error={!!this.getErrorFor("fixedFee")}
                                  helperText={this.getErrorFor("fixedFee")}
                                  disabled={!this.state.agencyFee?.isConcept || this.state.agencyFee?.removed}
                                />
                              </div>

                              <Select
                                className="form-input scroll-to-currency correct-label-position"
                                style={{width: "30%"}}
                                error={this.getErrorFor("currency")}
                                value={this.state.currency}
                                onChange={this.sync.bind(this, this.syncronizers.CURRENCY)}
                                htmlFor="currency"
                                name="currency" 
                                id="currency"
                                disabled={!this.state.agencyFee?.isConcept || this.state.agencyFee?.removed}
                              >
                                {this.getCurrencySelectboxes()}
                              </Select>
                            </div>
                            <div className="hint-styles-dialog" style={{margin: "0"}}>
                              {this.trans("dialog/agencyfee-info/amount")}
                            </div>

                            {/* <div style={{display: "flex", alignItems: "flex-start"}}>
                              <div style={{width: "50%", marginRight: "20px"}}>
                                <TextField
                                  autoComplete="off"
                                  className="form-element full-size scroll-to-vat"
                                  type="text"
                                  label={this.trans("dialog/agencyfee-field/vat-label")}
                                  value={this.state.vat}
                                  onChange={this.changeVatAmount}
                                  variant="standard"
                                  error={!!this.getErrorFor("vat")}
                                  disabled={!this.state.agencyFee?.isConcept || this.state.agencyFee?.removed}
                                />
                                {!!this.getErrorFor("vat") && <div className="component-error-text">{this.getErrorFor("vat")}</div>}
                              </div>
                              <div style={{width: "50%"}}>
                                <TextField
                                  autoComplete="off"
                                  className="form-element full-size scroll-to-vatPercentage"
                                  type="text"
                                  label={this.trans("dialog/agencyfee-field/vatpercentage-label")}
                                  value={this.state.vatPercentage}
                                  onChange={this.changeVatPercentageAmount}
                                  variant="standard"
                                  error={!!this.getErrorFor("vatPercentage")}
                                  disabled={!this.state.agencyFee?.isConcept || this.state.agencyFee?.removed}
                                />
                                {!!this.getErrorFor("vatPercentage") && <div className="component-error-text">{this.getErrorFor("vatPercentage")}</div>}
                              </div>
                            </div> */}

                            <TextField
                              autoComplete="off"
                              className="form-element scroll-to-percentageFee"
                              type="text"
                              label={this.trans("dialog/agencyfee-field/percentagefee-label")}
                              value={this.state.percentageFee}
                              onChange={this.changePercentageFeeAmount}
                              variant="standard"
                              error={!!this.getErrorFor("percentageFee")}
                              style={{width: "calc(70% - 7px)"}}
                              disabled={!this.state.agencyFee?.isConcept || this.state.agencyFee?.removed}
                            />
                            {!!this.getErrorFor("percentageFee") && <div className="component-error-text">{this.getErrorFor("percentageFee")}</div>}
                            <div className="hint-styles-dialog" style={{margin: "-14px 0 10px 0"}}>
                              {this.trans("dialog/agencyfee-info/percentagefee")}
                            </div>

                            <Select
                              className="form-element full-size form-input scroll-to-unitTypeId correct-label-position"
                              error={this.getErrorFor("assignmentServiceStatusId")}
                              value={this.state.assignmentServiceStatus}
                              onChange={this.changeAssignmentServiceStatus}
                              htmlFor="assignmentServiceStatusId"
                              label={this.trans("page/unitupdate-section/info-changeunitservicestatus/label")}
                              name="assignmentServiceStatus" 
                              id="assignmentServiceStatus"
                              disabled={!this.state.agencyFee?.isConcept || this.state.agencyFee?.removed}
                            >
                              <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(2).toLowerCase()}`)}</MenuItem>
                              <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(5).toLowerCase()}`)}</MenuItem>
                              <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(4).toLowerCase()}`)}</MenuItem>
                              <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(3).toLowerCase()}`)}</MenuItem>
                            </Select> 

                            <Select
                              className="form-element full-size form-input scroll-to-repeat-period correct-label-position"
                              error={this.getErrorFor("repeat-period")}
                              value={this.state.repeatPeriod}
                              onChange={this.sync.bind(this, this.syncronizers.REPEAT_PERIOD)}
                              htmlFor="repeatPeriod"
                              label={this.trans("dialog/defaultchargetemplates-field/period-label")}
                              name="repeatPeriod" 
                              id="repeatPeriod"
                              disabled={!this.state.agencyFee?.isConcept || this.state.agencyFee?.removed || this.state.assignmentServiceStatus === AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")}
                            >
                              {this.getRepeatPeriodAgreementSelectboxes(this.state.assignmentServiceStatus)}
                            </Select>

                            {parseFloat(this.state.percentageFee?.replace(",", ".")) > 0 && this.renderChargeTypesSelect()}

                            {parseFloat(this.state.percentageFee?.replace(",", ".")) > 0 && (
                              <Select
                                className="form-element full-size form-input scroll-to-fixedPlusPercentageMode correct-label-position"
                                error={this.getErrorFor("fixedPlusPercentageMode")}
                                value={this.state.fixedPlusPercentageMode && this.state.fixedPlusPercentageMode.id}
                                onChange={this.updateFPPMode}
                                htmlFor="fixedPlusPercentageMode"
                                label={this.trans("dialog/agencyfee-field/fixedpluspercentagemode-label")}
                                name="fixedPlusPercentageMode" 
                                id="fixedPlusPercentageMode"
                                disabled={!this.state.agencyFee?.isConcept || this.state.agencyFee?.removed}
                              >
                                {
                                  Object.keys(this.props.globalTypes?.FixedPlusPercentageModes || {}).map((fpp) => {
                                    let fpps = this.props.globalTypes?.FixedPlusPercentageModes?.[fpp];

                                    return (
                                      <MenuItem key={fpps.id} value={fpps.id}>{this.formatter.checkTranslationType(this.trans(fpps.label), fpps.label)}</MenuItem>
                                    );
                                  })
                                }
                              </Select>
                            )}

                            <div>
                              { 
                                this.state.agencyFee?.isConcept && (
                                  <div>
                                    <div
                                      style={{
                                        marginRight: "15px",
                                        color: "gray",
                                        width: "250px"
                                      }}
                                    >
                                      {this.trans("dialog/agencyfee-radio/dates-hint")}
                                    </div>

                                    <RadioGroup
                                      name="dateChoice"
                                      value={this.state.dateChoice}
                                      onChange={this.changeDateChoice}
                                      style={{
                                        display: "flex",
                                        flexDirection: "row"
                                      }}
                                    >
                                      <FormControlLabel
                                        value="firstDate"
                                        control={<Radio color="primary" />}
                                        label={
                                          (<span>{this.trans("dialog/agencyfee-field/firstdate-radiobutton")}</span>)}
                                      />
                                      {/* <FormControlLabel
                                        value="contractDate"
                                        control={<Radio color="primary" />}
                                        label={
                                          (<span>{this.trans("dialog/agencyfee-field/startfromcontractdate-label")}</span>)}
                                      /> */}
                                    </RadioGroup>
                                  </div>
                                )
                              }

                              {
                                this.state.dateChoice === "firstDate" && this.state.agencyFee?.isConcept && (
                                  <DatePickerComponent
                                    {...this.props}
                                    id="firstDate"
                                    name="firstDate"
                                    className="scroll-to-firstDate"
                                    label={this.trans("dialog/agencyfee-field/firstdate-label")}
                                    initialDate={this.state.firstDate}
                                    maxDate={activeContract && activeContract?.firstDate}
                                    onChange={date => this.selectDate(date, "firstDate")}
                                    clearButton={true}
                                    width="70%"
                                    margin={"0 0 10px 0"}
                                    error={this.getErrorFor("firstDate") || this.state.firstDateError}
                                    disabled={!this.state.agencyFee?.isConcept || this.state.agencyFee?.removed}
                                  />
                                )
                              }
                      
                              {
                                !this.state.agencyFee?.isConcept && this.state.lastDate && (
                                  <div style={{display: "flex", justifyContent: "flex-start", alignItems: "center"}}>
                                    <DatePickerComponent
                                      {...this.props}
                                      id="lastDate"
                                      name="lastDate"
                                      className="scroll-to-lastDate"
                                      minDate={this.state.firstDate}
                                      minDatePlusDays={1}
                                      minDateMessage={this.trans("field/lastfinalenddate-info/error")}
                                      label={this.state.lastDate ? this.trans("label/end-date") + this.trans("field/optional") : this.trans("end-date-not-set") + this.trans("field/optional")}
                                      initialDate={this.state.lastDate}
                                      value={this.state.lastDate}
                                      clearButton={true}
                                      width="70%"
                                      error={this.getErrorFor("lastDate")}
                                      disabled={true}
                                    />
                                  </div>  
                                )
                              }
                            </div>
                          </div>
                        </Card>
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={"right-panel-wrapper"}>
            <EntityLaunchpanel
              {...this.props}
              entityTitle={this.trans("launchpanel-agreement-title")}
              actionsList={
                <List component="div" disablePadding>
                  {
                    this.state.agencyFee?.isSigned &&
                    <ListItem
                      button
                      key="menuitem-set-end-date"
                      alignItems="flex-start"
                      onClick={() => {
                        if (this.checkProcessIsBusy({
                                                  action: "end",
                                                  entityName: "agencyFee",
                                                  entity: this.state.agencyFee
                                                })) {
                          this.openIsBusyPopup();
                          this.setState({anchorEl: null});
                        } else if (this.state.hasModifiedData) {
                          this.setState({
                            isErrorLaunchPanelOpen: true,
                            anchorEl: null,
                            openLeavePrompt: true
                          })
                        } else {
                          this.setState({
                            isEndAgencyFeeDialogOpen: true
                          })
                        } 
                      }}
                      disabled={this.state.agencyFee?.removed}
                      style={{padding: "1px 16px"}}
                    >
                      <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-stop"></div></ListItemIcon>
                      <ListItemText primary={this.trans("page/agreementupdate-launchpanel/setenddate")} secondary={this.trans("page/agreementupdate-launchpanel/setenddate-hint")} />
                    </ListItem>
                  }
                  {(this.state.agencyFee?.isEnding || this.state.agencyFee?.isEnded) && (
                    <ListItem
                      button
                      key="menuitem-clear-end-date"
                      alignItems="flex-start"
                      onClick={() => {
                        if (this.checkProcessIsBusy({
                                                action: "end",
                                                entityName: "agencyFee",
                                                entity: this.state.agencyFee
                                              })) {
                          this.openIsBusyPopup();
                          this.setState({anchorEl: null});
                        } else if (this.state.hasModifiedData) {
                          this.setState({
                            isErrorLaunchPanelOpen: true,
                            anchorEl: null,
                            openLeavePrompt: true
                          })
                        } else {
                          this.selectDate(null, "lastDate", this.setEndDate);
                        } 
                      }}
                      style={{padding: "1px 16px"}}
                    >
                      <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-stop"></div></ListItemIcon>
                      <ListItemText primary={this.trans("page/agreementupdate-launchpanel/clearenddate")} secondary={this.trans("page/agreementupdate-launchpanel/clearenddate-hint")} />
                    </ListItem>
                  )}
                  <ListItem
                    button
                    key="menuitem-delete"
                    alignItems="flex-start"
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                                                action: "remove",
                                                entityName: "agreement",
                                                entity: this.state.agencyFee
                                              })) {
                        this.openIsBusyPopup();
                        this.setState({anchorEl: null});
                      } else {
                        this.setState({ isAgencyFeeRemoveDialog: true})
                      }
                    }}
                    style={{padding: "1px 16px"}}
                  >
                    <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-remove"></div></ListItemIcon>
                    <ListItemText primary={this.trans("menuitem-delete-agreement")} secondary={this.trans("page/agreementupdate-launchpanel/delete-hint")} />
                  </ListItem>
                </List>
              }
            />
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={
            <div>
              <div style={{marginBottom: "10px"}}>{this.trans("agreement-sign-warning")}</div>
              {this.state.firstDate ? 
                <div>{this.trans("agreement-sign-warning-1", {firstDate: this.formatter.formatDate(this.state.firstDate)})}</div> :
                <div>{this.trans("agreement-sign-warning-3")}</div>}
            </div>
          }
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-continue")}
          openLeavePrompt={this.state.isSignPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => this.setState({isSignPopupOpen: false})}
          onSave={() => {
            if (!this.state.date) {
              return this.setState({
                dateError: this.trans("be_ajv_not_validated"),
                isSignPopupOpen: false
              })
            }
            this.setState({isSignPopupOpen: false}, () => {
              if (this.state.hasModifiedData) {
                this.save(this.sign);
              } else {
                this.sign();
              }
            });
          }}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("end-agency-fee-modal-title")}
          content={(
            <div>
              <p>{this.trans("dialog/preprocess-endagencyfee-info1")}</p>
              <div style={{width: "50%"}}>
                <DatePickerComponent
                  {...this.props}
                  label={this.state.lastDate ?
                    this.trans("end-date") : this.trans("label-click-set-the-end-date")}
                  initialDate={this.state.lastDate ? this.state.lastDate : null}
                  minDate={this.state.firstDate}
                  minDatePlusDays={1}
                  minDateMessage={this.trans("field/lastfinalenddate-info/error")}
                  onChange={date => this.selectDate(date, "lastDate")}
                  clearButton={true}
                  error={this.getErrorFor("lastDate")}
                />
              </div>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("set-end-date")}
          positiveButtonStyle={{backgroundColor:"red"}}
          openLeavePrompt={this.state.isEndAgencyFeeDialogOpen}
          onDiscard={() => {
            this.selectDate(this.state?.agencyFee?.lastDate, "lastDate");
            this.setState({isEndAgencyFeeDialogOpen: false, hasModifiedData: false});
          }}
          onSave={() => this.setState({isEndAgencyFeeDialogOpen: false}, this.setEndDate)}
          hideCross={true}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={"dialog/remove-contract"}
          isOpen={this.state.isAgencyFeeRemoveDialog}
          onCancel={() => this.setState({isAgencyFeeRemoveDialog: false})}
          onDelete={this.deleteAgencyFee}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.state.isErrorLaunchPanelOpen ? () => this.setState({openLeavePrompt: false,hasModifiedData: false, additionalSectionHasModifiedData: false}) : this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    properties: state.properties,
    units: state.units,
    events: state.events,
    component: state.agencyFeeUpdate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  AgreementUpdate
);
